module.exports = __webpack_public_path__ + "static/media/confirm-password.100eb46f.svg";